export const typesProveedorEstadosMunicipios = {
  storeEstadosMunicipios: "storeEstadosMunicipios",
  proveedorMunicipiosOrigen: "proveedorMunicpios",
  proveedorMunicipiosDestino: "proveedorMunicpiosDestino",
  storeProvedoresMuncipiosLps: "storeProvedoresMuncipiosLps",

}
